document.addEventListener('DOMContentLoaded', function() {
  const megaMenus = document.querySelectorAll('.mega-menu');
  let currentTimeout = null;
  let currentOpenMenu = null;
  
  megaMenus.forEach(menu => {
    const details = menu;
    const summary = menu.querySelector('summary');

    // Handle hover to open/close
    menu.addEventListener('mouseenter', () => {
      // Clear any existing timeout
      if (currentTimeout) {
        clearTimeout(currentTimeout);
        currentTimeout = null;
      }

      // If there's a different menu open, close it immediately
      if (currentOpenMenu && currentOpenMenu !== details) {
        currentOpenMenu.removeAttribute('open');
      }

      // Set current menu as open
      currentOpenMenu = details;
      details.setAttribute('open', true);
      
      // Show first child image by default
      const firstChild = menu.querySelector('.mega-menu__child-link');
      if (firstChild) {
        const menuItemId = firstChild.id;
        const megaMenuContent = firstChild.closest('.mega-menu__content');
        const dropdownImageNav = megaMenuContent.querySelector('.dropdownImagenav');
        
        const imageUrl = window.menuImageConfig[menuItemId] || null;
        dropdownImageNav.style.backgroundImage = imageUrl ? `url(${imageUrl})` : 'none';
      }
    });

    menu.addEventListener('mouseleave', () => {
      // Set timeout for closing
      currentTimeout = setTimeout(() => {
        details.removeAttribute('open');
        currentOpenMenu = null;
        currentTimeout = null;
      }, 500);
    });
  });
});
